import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import {inject} from 'mobx-react';

import CharacterModel from '../component/CharacterModel';
import EventModel from '../component/eventmodel';
import EnvironmentModel from '../component/EnvironmentModel';

@withRouter
@inject("store")

export default class StoryModel extends Component
{

  next(){
    this.props.store.storymodel = "next";
    this.forceUpdate();
  }

    character(){
        this.props.store.storymodel = "character";
        this.props.store.charactermodel = "nothing";
        this.forceUpdate();
      }
    
      event(){
        this.props.store.storymodel = "event";
        this.props.store.eventmodel = "nothing";
        this.forceUpdate();
      }
    
      environment(){
        this.props.store.storymodel = "environment";
        this.props.store.environmentmodel="nothing";
        this.forceUpdate();
      }
   
    render()
    {
        return <div className = "storymodel">
          
              <img src={cookie} className="cookiepicture" alt="cookie" />
              <br/>
              {this.props.store.storymodel == "nothing" && <div className = "modeltext">  之前，我们学了用穷举法筛选出更好的故事。
          <br/><br/>
          但穷举是有极限的，如果没有经验，没有积累足够的素材。很难写出满意的东西来。
          所以在这里，提供一些现成的故事模版。<br/><br/>
          依旧是人物，事件，环境三个方向，请选择想要了解的模版<br/>
        <div className= "buttonbox">
          <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.character() } >人物</Button><br/>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.event() }  >事件</Button><br/>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.environment() } >环境</Button><br/>
          </div>

          <br/><br/>
          在看完感兴趣的模版，练习之后，请点下一步
          <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.next() } >下一步</Button><br/>
       
          </div>}

          {this.props.store.storymodel == "character" && <CharacterModel/>}

          {this.props.store.storymodel == "event" && <EventModel/>}

          {this.props.store.storymodel == "environment" && <EnvironmentModel/>}

          {this.props.store.storymodel == "next" && <div className = "modeltext">
            现在你已经完成了故事指南的所有内容了<br/>
            恭喜！<br/><br/>
            应该已经可以自己写故事了吧！<br/>
            接下来就是多写多看，就能写得越来越好啦<br/><br/>
            当然如果还想提升，可以看看其他部分<br/>
            下次进来，先点“要听”，然后在介绍界面点“写过一些，但不太满意”就行啦<br/>
            不过在此之前，先尽量多写点吧~<br/><br/>

            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.props.history.push("/")} >回到首页</Button><br/>
            </div>}
            
             



        </div>;
    }
} 